import "./App.css";
import "./assets/font/font.css";
import {
  Switch,
  Redirect,
  Route,
  BrowserRouter as Router,
} from "react-router-dom";
import Page from "./mui/Page";
import { ToastContainer } from "react-toastify";
import RTLProvider from "./utils/RTLProvider";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <RTLProvider>
      <div className="w-screen h-screen">
        <ToastContainer />
        <Router forceRefresh={true}>
          <Switch>
            <Route exact path="/form" component={Page} />
            <Redirect to={"/form"} />
          </Switch>
        </Router>
      </div>
    </RTLProvider>
  );
}

export default App;
